<template>
  <div class="intro">
    <div class="w-full h-full inset-0 absolute z-10" v-if="!started">
      <img class="w-full h-full" src="/showroom/media/start-splashscreen.jpg" />
    </div>
    <!-- intro video -->
    <video class="w-full h-full inset-0 absolute z-0" ref="intro">
      <source src="/showroom/media/intro.mp4" type="video/mp4" >
    </video>
    <!-- video last frame -->
    <div class="w-full h-full inset-0 absolute z-0" v-if="finished">
      <img class="w-full h-full" src="/showroom/media/intro-splashscreen-2.jpg" />
    </div>
    <!-- first wizard -->
    <div class="z-10 relative flex justify-center items-center w-full h-full" v-if="wizard">
      <button class="btn-play" @click="play()"><font-awesome-icon class="ml-1" :icon="['fas', 'play']" /></button>
    </div>
    <!-- skip button -->
    <div class="z-20 relative flex justify-end items-end w-full h-full" v-if="!wizard && !finished">
      <button class="btn btn-secondary btn-small mr-1 mb-1 xl:mr-4 xl:mb-4" @click="skip()">{{ $t('intro.skip') }}</button>
    </div>
    <!-- after video fin -->
    <div v-if="finished" class="outro w-full h-full inset-0 absolute z-30">
      <div ref="buttons" class="w-full h-full relative flex justify-center items-center" :class="{ 'aniIntro_buttonsIn': finished && !removeAnimation, 'aniIntro_buttonsOut': addAnimation, 'aniIntro_buttonHelper': removeAnimation }">
        <!-- connectivity -->
        <div class="flex flex-col w-1/2 xl:w-2/5">
          <div class="flex flex-row w-full justify-between">
            <button @click="goToHeater()" class="btn btn-primary opacity-0">
              <span>{{ $t("heater") }}</span>
            </button>
            <button @click="goToControls()" class="btn btn-primary opacity-0">
              <span>{{ $t("controls") }}</span>
            </button>
          </div>
          <div class="flex flex-row w-full justify-between mt-24">
            <button @click="goToActuators()" class="btn btn-primary opacity-0">
              <span>{{ $t("actuators") }}</span>
            </button>
            <button @click="goToConnectivity()" class="btn btn-primary opacity-0">
              <span>{{ $t("connectivity") }}</span>
            </button>
          </div>
        </div>
        <button class="btn btn-secondary absolute bottom-0 right-0 btn-small mr-1 mb-1 xl:mr-4 xl:mb-4 opacity-0" @click="repeat()">{{ $t('intro.repeat') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  data() {
    return {
      wizard: true,
      finished: false,
      removeAnimation: false,
      addAnimation: false,
      started: false,
    }
  },
  methods: {
    play() {
      this.started = true;
      this.$refs.intro.play();
      this.wizard = false;
      setTimeout(() => {
        this.finished = true;
      },28000);
    },
    skip() {
      this.started = true;
      this.$router.push({ path: '/', query: { skip: 1, lang: this.$i18n.locale }});
      location.reload();
    },
    repeat() {
      this.$router.push({ path: '/?lang=' + this.$i18n.locale });
      location.reload();
    },
    goToConnectivity() {
      this.removeAnimation = true;
      // reset animation
      setTimeout(() => { this.addAnimation = true; },1)
      setTimeout(() => {
        this.$router.push({ path: 'connectivity', query: { lang: this.$i18n.locale }});
      }, 300)
    },
    goToHeater() {
      this.removeAnimation = true;
      // reset animation
      setTimeout(() => { this.addAnimation = true; },1)
      setTimeout(() => {
        this.$router.push({ path: 'beheizungen', query: { lang: this.$i18n.locale }});
      }, 300)
    },
    goToControls() {
      this.removeAnimation = true;
      // reset animation
      setTimeout(() => { this.addAnimation = true; },1)
      setTimeout(() => {
        this.$router.push({ path: 'steuerungen', query: { lang: this.$i18n.locale }});
      }, 300)
    },
    goToActuators() {
      this.removeAnimation = true;
      // reset animation
      setTimeout(() => { this.addAnimation = true; },1)
      setTimeout(() => {
        this.$router.push({ path: 'aktoren', query: { lang: this.$i18n.locale }});
      }, 300)
    }
  },
  // check if user is comming back from connectivity
  mounted() {
    if(this.$route.query.skip == 1) {
      this.$data.started = true;
      this.$data.wizard = false;
      this.$data.finished = true;
    }
    this.$i18n.locale = this.$route.query.lang;
  }
}
</script>

<style lang="scss">
.btn-wrapper {
  bottom: 59%;
}

// animations
.aniIntro_buttonsIn .btn {
  animation: reveal100 .3s ease .5s forwards;
}
.aniIntro_buttonsOut .btn {
  animation: reveal100 .2s ease reverse forwards;
}
.aniIntro_buttonHelper .btn {
  opacity: 1;
}
</style>
